module.exports = __webpack_public_path__ + "assets/e5c785c01a7567650787ba833687635a.svg";